module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-bar"
  }, [_vm._v("© Colombbus 2018 - "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "mailto:declick@colombbus.org"
    }
  }, [_vm._v("contact")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-286a2f0b!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/navigation/FooterBar.vue
// module id = 588
// module chunks = 2